











































































































































































































import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import Axios from 'axios';
import { ConversationViewModel } from './conversationViewModel';
import * as marked from 'marked';
import { storeService } from '@/shared';

@Component({
  props: ["methodName", "progress"],
  data() {
    return {
      noteText: ''
    };
  },
  components: {
    AppDialog: () => import('@/components/common/app.dialog.vue')
  },
  watch: {
    noteText() {
      this.$nextTick(() => {
        // Requesting animation frame to ensure the DOM is updated
        requestAnimationFrame(() => {
          const textArea = this.$refs.noteTextArea.$el.querySelector('textarea');
          if (textArea) {
            // Ensure the max-height is applied and scrolling is enabled
            textArea.style.maxHeight = 'calc(6 * 30px)';
            textArea.style.overflowY = 'auto';
            // Scroll to the bottom
            textArea.scrollTop = textArea.scrollHeight + 2;
            if (textArea.scrollTop < 98) {
              this.textareaStyle = "display: 'inline-block';max-height: 'calc(6 * 24px)';margin-bottom:'-20px';font-weight: 100;font-size: 16px;";
            } else {
              this.marginBottom = "display: 'inline-block';max-height: 'calc(6 * 24px)';margin-bottom:'-10px';font-weight: 100;font-size: 16px;";
            }
          }
        });
      });
    }
  },
})


export default class ClaudeCustomerSupportPage extends Base {
  public textareaStyle: string = "display: 'inline-block';max-height: 'calc(6 * 24px)';margin-bottom:'-20px';";
  public marginBottom: string = "-20px";
  public noteText: string = "";
  public requestProgress: boolean = false;
  public botDummyLoading: boolean = false;
  public botDummyTextLoading: boolean = false;
  public btnrequestprogress: boolean = false;
  public isChatInitiate: boolean = true;
  public isFirst: boolean = true;
  public storeId: string = "1";
  public isChatPopupVisible: boolean = true;
  public userId = Utils.newGuid();
  public conversationModel: ConversationViewModel = {
    conversationId: '',
    content: '',
    isMessageEnabled: true
  };
  public conversationHistory: ConversationViewModel[] = [];
  public assistantMemory = [];
  public showChatInitiateLoader: boolean = false;
  public StoreKey: string = "";
  public StoreLogo: string = "";
  //public sessionExpiringLoader:boolean = false;
  //public sessionInitiated:boolean = true;
  public disableMessageField: boolean = false;
  public inactivityTime = 300000; // 5 minutes in milliseconds
  public timeout;
  public websiteUrl: string = "";
  public authorized: boolean = false;
  public isAdminAccess: boolean = false;
  public checkAccess: boolean = false;
  public showInitialLoader: boolean = true;
  public showUnauthorizedLoader: boolean = true;
  public storeName: string = "";
  public created() {

    window.onbeforeunload = this.eraseUser;
  }

  public async mounted(): Promise<void> {

    this.StoreKey = this.$route.params.storeKey;
    await this.GetStoreLogo();
    this.IsAccessAllowed();
    if (this.authorized || this.isAdminAccess) {
      await this.OnClickChatInitiate();

    }
    else {
      this.showInitialLoader = false;
      this.isChatInitiate = false;
    }

    // Detect user activities: mouse, keyboard, etc.
    window.onload = this.resetTimer;
    window.onmousemove = this.resetTimer;
    window.onkeydown = this.resetTimer;
    window.onclick = this.resetTimer;
    window.onscroll = this.resetTimer;

    // Monitor user activity to reset inactivity timeout
    // document.addEventListener('mousemove', this.resetInactivityTimer);
    // document.addEventListener('keypress', this.resetInactivityTimer);
  }


  public async IsAccessAllowed() {
    try {

      let tempData = this.websiteUrl.split('.');
      if (tempData && tempData.length > 0) {
        this.websiteUrl = tempData[0];
      }
      let ancestorUrl = [...window.location.ancestorOrigins];
      ancestorUrl.forEach(element => {
        let hostNames = element.split('.');
        hostNames.forEach(names => {
          if (names.toLowerCase() == this.websiteUrl.toLowerCase()) {
            this.authorized = true;
          }
        });
      });

    } catch (ex) {
      console.error("Error fetching store information:", ex);

    }
  }
  public async GetStoreLogo(): Promise<void> {

    try {
      this.showUnauthorizedLoader = true;
      const data = await storeService.GetStoreLogoByStoreKey(this.StoreKey);
      if (data) {
        this.StoreLogo = data.storeLogo;
        this.websiteUrl = data.webSiteUrl;
        this.isAdminAccess = data.isAdminView;
        this.storeName = data.storeName;
      }

      // // let tempData = data.webSiteUrl.split('.');
      // if (tempData && tempData.length > 0) {
      //   this.websiteUrl = tempData[0];
      // }

    } catch (ex) {
      console.error("Error fetching store logo:", ex);

    }
    finally {
      this.showUnauthorizedLoader = false;
    }
  }


  public eraseUser() {
    Axios({
      method: 'post',
      url: Utils.WEB_BASE_URL + `/erase/user/${this.$route.params.storeKey}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        conversationId: this.conversationModel.conversationId
      }
    }).then(() => {

    }).catch(() => {
      this.showAlert(false, "Please try again later");
    });

  }

  public handleEvent(event) {
    if (event.key == 'Enter') {
      if (!event.shiftKey) {
        event.preventDefault();
        this.sendText();

      }
    }
  }


  public sendText() {

    if (this.noteText.trim() != "") {

      //for maintaining user session time
      // if(this.sessionInitiated){
      //   this.sessionInitiated = false;
      //   this.startUserSession();
      // }

      this.requestProgress = true;
      const newMessage: any = {
        role: 'user',
        content: this.noteText,
        isMessageEnabled: true
      };

      this.conversationHistory.push(newMessage);

      this.requestProgress = false;
      window.setTimeout(() => {
        this.scrollToBottom();
      }, 10);
      this.btnrequestprogress = true;
      this.botDummyLoading = true;
      this.botDummyTextLoading = false;

      var dummyTextTimeout = setTimeout(() => {
        this.botDummyTextLoading = true;
      }, 3000);

      Axios({
        method: 'post',
        //url: Utils.WEB_BASE_URL + '/customer/care/support',
        url: Utils.WEB_BASE_URL + `/customer/service/chat/${this.$route.params.storeKey}`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          // conversationHistoryList: this.conversationHistory,
          conversationId: this.conversationModel.conversationId,
          userQuery: newMessage
        },

      }).then((response) => {
        if (response != null && response != undefined && response.data != '') {
          var model = { role: "", content: "", isMessageEnabled: true };
          model.role = "assistant";
          model.content = marked(response.data.assistantMessage);

          const keywords = ["restart", "refresh", "renew"];
          const isRestartSession = keywords.some(keyword =>
            new RegExp(`\\b${keyword}`, 'i').test(model.content)
          );
          if (isRestartSession) {
            this.RestartChatSession();
          }
          this.requestProgress = true;
          this.btnrequestprogress = true;
          this.conversationHistory.push(model);
          this.noteText = "";
          this.requestProgress = false;
          this.btnrequestprogress = false;
          this.botDummyLoading = false;
          this.botDummyTextLoading = false;
          clearTimeout(dummyTextTimeout);
        }
        else {
          this.showAlert(false, "Please try again later");
        }

        window.setTimeout(() => {
          this.scrollToBottom();
        }, 10);
      })
        .catch((error) => {
          this.btnrequestprogress = false;
          this.botDummyLoading = false;
          this.showAlert(false, "Please try again later");
        });
    }

    this.noteText = "";
    const textArea = this.$refs.noteTextArea as HTMLElement;
    textArea.focus();

    // const connection = new HubConnectionBuilder()
    //     .withUrl(Utils.API_Web_HUB_URL)
    //     .configureLogging(LogLevel.Information)
    //     .build();

    // connection
    //     .start()
    //     .then(function () {

    //         const channelId = this.store + "_" + this.userId
    //             .replace('@', '')
    //             .replace(/\./g, '')
    //             .trim();

    //         connection
    //             .invoke('getClaudeMessages', channelId, this.conversationHistory)
    //             .then(function (connectionId) {
    //             })
    //             .catch((err) => console.error(err.toString()));
    //     })
    //     .catch(function (err) {
    //         console.log(err.toString());
    //     });

    // connection.on('messagesNotification', function (data) {
    //     this.GetMessages(data);
    // });

  }

  public scrollToBottom() {
    const messageContainer = this.$refs.messageContainer as HTMLElement;
    if (messageContainer) {
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
  }


  public async OnClickChatInitiate() {

    try {
      this.showChatInitiateLoader = true;
      // var btn = document.getElementById("chatInitiateBtn");
      // btn.setAttribute("disabled", "true");
      this.isChatInitiate = true;
      Axios({
        method: 'post',
        url: Utils.WEB_BASE_URL + `/initiate/chat/${this.$route.params.storeKey}`,

      }).then((response) => {
        if (response != null && response != undefined && response.data != '') {
          if (response.data.isStoreFetched) {

            var model = { role: "", content: "", isMessageEnabled: true };
            model.role = "assistant";
            model.content = marked(response.data.assistantMessage);

            this.conversationModel.conversationId = response.data.conversationId;
            this.requestProgress = true;
            this.conversationHistory.push(model);
            this.noteText = "";
            this.requestProgress = false;

            this.showChatInitiateLoader = false;
            this.isChatInitiate = false;
            this.showInitialLoader = false;

          }
          else {
            this.isChatInitiate = false;
            this.showChatInitiateLoader = false;
            this.showInitialLoader = false;
            // btn.removeAttribute("disabled");
            this.showAlert(false, response.data.assistantMessage);
          }
        }
        else {
          this.isChatInitiate = false;
          this.showChatInitiateLoader = false;
          this.showInitialLoader = false;
          // btn.removeAttribute("disabled");
          this.showAlert(false, "Please try again later");
        }
      }).catch((error) => {
        this.showChatInitiateLoader = false;
        this.showInitialLoader = false;
        // btn.removeAttribute("disabled");
        this.showAlert(false, "Please try again later");
        this.isChatInitiate = false;
      });
    } finally {
      this.showChatInitiateLoader = false;
      this.showInitialLoader = false;
      //this.isChatInitiate = false;
    }
  }

  public closeChat() {

    this.eraseUser();
    this.conversationHistory = [];
    this.disableMessageField = false;
    this.OnClickChatInitiate();

  }

  public RestartChatSession() {
    this.conversationHistory.forEach(item => {
      item.isMessageEnabled = false;
    });
  }

  //public timeRemaining = 60 * 2; // 2 minutes in seconds
  //public timerInterval = null;
  // public inactivityTimeout;
  // public inactivityLimit = 60 * 1; // 5 seconds without activity

  // public startUserSession() {
  //   if(!this.timerInterval && !this.sessionInitiated)
  //   {  
  //     this.timerInterval = setInterval(() => 
  //     {
  //       if (this.timeRemaining > 0) {
  //         if(this.timeRemaining <= 10)
  //           this.sessionExpiringLoader = true;

  //         console.log(this.timeRemaining);
  //         this.timeRemaining--;
  //       } 
  //       else {
  //         debugger
  //         this.userSessionExpire();

  //         clearInterval(this.inactivityTimeout);
  //         clearInterval(this.timerInterval);
  //         document.getElementById('timer').textContent = "Time's up!";
  //       }
  //     }, 1000);
  //   }
  // }

  public userSessionExpire() {
    Axios({
      method: 'post',
      url: Utils.WEB_BASE_URL + `/user/session/timeout`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        conversationId: this.conversationModel.conversationId
      },
    })
      .then((response) => {
        if (response != null && response != undefined && response.data != '') {
          if (response.data) {
            //this.sessionExpiringLoader = false;
            this.disableMessageField = true;

            const newMessage: any = {
              role: 'assistant',
              content: "Thanks for contacting us. Your session has timed out due to inactivity. Please refesh the page or start from store website.",
              isMessageEnabled: true
            };
            this.conversationHistory.push(newMessage);
          }
        }
      }).catch((error) => {

      });
  }

  // Pause the timer
  // public pauseTimer() {
  //   // clearInterval(this.timerInterval);
  //   // this.timerInterval = null;
  // }

  // public resetInactivityTimer() {
  //   if(!this.sessionInitiated){
  //     debugger  
  //     // Resume timer if it's paused
  //     //this.startUserSession()

  //     // Pause after inactivity
  //     this.inactivityTimeout = setTimeout(()=> {
  //       debugger
  //       //this.pauseTimer();

  //       if(this.inactivityLimit <= 10){
  //         this.sessionExpiringLoader = true;
  //       }

  //       this.userSessionExpire();
  //     }, this.inactivityLimit);
  //   }
  // }


  // Reset the timer on user activity
  public resetTimer() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.userSessionExpire();
    }, this.inactivityTime);
  }

}

